export enum DesignatedRequestType {
  DtrAmendment = "dtr_amendment",
  BreakAmendment = "break_amendment",
  Overtime = "overtime",
  Leave = "leave",
  ChangeShift = "change_shift",
}
